/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_tp.js                                                                                */
/**********************************************************************************************************************/
/* Controller.TP */

/**
 * @class this.Controller.TP
 */
HafasWebapp.prototype.Controller.TP = {
  /**
   * @class this.Controller.TP.index
   *
   * @param data
   */

  // Strawberry 1.5: [BugFix] Von kleinigkeiten die in der RMV Version aufgefallen sind und [Upgrade] schnelleres Rendern ohne klonen
  currentView: null,

  index: function () {


    Hafas.bind(this.Controller.TP.cleanup, this)();

    this.Controller.TP.outwardDateTimePicker = null;
    this.Controller.TP.currentTripResult = null;
    this.Controller.TP.ticketSelection = new Hafas.model.connection.TicketSelection();
    this.Controller.TP.currentView = "index";
    this.Controller.TP.isTicketBannerDetailsOpen = false;
    this.Controller.TP.currPassangerCount = 1;
    this.Controller.TP.tmpCurrPassangerCount = 1;
    if (Hafas.Modules.History)
      Hafas.Modules.History.addData("TP", "index", {});

    this.Controller.TP.lastSearchType = "top";

    this.Controller.TP.timePeriodValues = [
      {time: "NOW", period: "NOW"},
      {time: "000000", period: "1440"},
      {time: "000000", period: "600"},
      {time: "090000", period: "360"},
      {time: "140000", period: "360"},
      {time: "180000", period: "360"}
    ];

    Hafas("#HFS_ContentWrap").innerHTML = Hafas.Modules.Render.renderTemplate("TP_TplContext", {});
    Hafas.bind(this.Controller.TP.renderInputFrom, this)();
    Hafas.ps.pub('/app/events/renderDone');
    Hafas.ps.pub('/app/contextLoaded/' + this.appContext);
  },
  renderInputFrom: function () {
    var model = {};
    model.allPassangers = this.Controller.TP.instance.getPassangerOptions().getAllPassangers().length;

    var me = this;
    Hafas("#HFS_TpInput").innerHTML = Hafas.Modules.Render.renderTemplate("TP_TplIndex", model);

    me.Controller.TP.inpFrom = Hafas.Core.newType('hafasSuggest', {
      loc: "From",
      config: Hafas.Config.Suggest,
      type: "S",
      onSelect: function (loc) {
        me.Controller.TP.instance.setLocation('dep', loc);
        Hafas.bind(me.Controller.TP.onFormularChange, me)();
      }
    });
    me.Controller.TP.inpTo = Hafas.Core.newType('hafasSuggest', {
      loc: "To",
      config: Hafas.Config.Suggest,
      type: "D",
      onSelect: function (loc) {
        me.Controller.TP.instance.setLocation('arr', loc);
        Hafas.bind(me.Controller.TP.onFormularChange, me)();
      }
    });

    me.Controller.TP.outDatePicker = Hafas.Core.newType('hafasTimeDatePicker', {
      holder: "HFS_OutDate_Holder",
      id: "HFS_OutDate",
      class: "",
      config: {},
      current: {
        date: me.Controller.TP.instance.getOutDate(),
        time: me.Controller.TP.instance.getOutTime(),
        enquiry: true
      },
      mobilTitle: Hafas.Modules.i18n.get("TP.index.t_N_DateTimePickerOut"),
      handlers: {
        onSelect: Hafas.bind(me.Controller.TP.actions.onChangeOutDate, me)
      }
    });

    me.Controller.TP.retDatePicker = Hafas.Core.newType('hafasTimeDatePicker', {
      holder: "HFS_RetDate_Holder",
      id: "HFS_RetDate",
      config: {},
      current: {
        date: me.Controller.TP.instance.getRetDate(),
        time: me.Controller.TP.instance.getOutTime(),
        enquiry: true
      },
      mobilTitle: Hafas.Modules.i18n.get("TP.index.t_N_DateTimePickerRet"),
      handlers: {
        onSelect: Hafas.bind(me.Controller.TP.actions.onChangeRetDate, me)
      }
    });

    me.Controller.TP.dateRangeHandler = Hafas.Core.newType('hafasDateRangeHandler', {
      startDatePicker: me.Controller.TP.outDatePicker,
      endDatePicker: me.Controller.TP.retDatePicker
    });

    var tmpLoc = me.Controller.TP.instance.getLocation("dep");
    if (tmpLoc != null) {
      me.Controller.TP.inpFrom.setLocation(tmpLoc);
    } else {
      // Instanz hat keinen Wert, gibt es ein StorageObjekt für dieses Feld?
      if (Hafas.ps.pub('/common/observe/inputvalues', ['get', me.Controller.TP.inpFrom.inp.id])) {
        me.Controller.TP.inpFrom.inp.value = Hafas.ps.pub('/common/observe/inputvalues', ['get', me.Controller.TP.inpFrom.inp.id]);
      }
    }

    tmpLoc = me.Controller.TP.instance.getLocation("arr");
    if (tmpLoc != null) {
      me.Controller.TP.inpTo.setLocation(tmpLoc);
    } else {
      // Instanz hat keinen Wert, gibt es ein StorageObjekt für dieses Feld?
      if (Hafas.ps.pub('/common/observe/inputvalues', ['get', me.Controller.TP.inpTo.inp.id])) {
        me.Controller.TP.inpTo.inp.value = Hafas.ps.pub('/common/observe/inputvalues', ['get', me.Controller.TP.inpTo.inp.id]);
      }
    }

    Hafas.bind(this.Controller.TP.InputFromEvents, this)("HFS_RetPeriodSelect", 0);
    Hafas.bind(this.Controller.TP.actions.onChangePeriod, this)("HFS_OutPeriodSelect", 0);
    Hafas.bind(this.Controller.TP.actions.onChangePeriod, this)("HFS_RetPeriodSelect", 0);

    // Track
    Hafas.ps.pub('/tracking/screen/journey-planner-main', [{typ: 'screen', key: 'journey-planner-main'}]);
    Hafas.ps.pub('/tracking/screen/tripplanner-main', [{typ: 'screen', key: 'tripplanner-main'}]);
  },
  InputFromEvents: function () {

    var tpForm = Hafas("#HFS_FormTripSearch"),
    inpFrom = Hafas('#' + this.Controller.TP.inpFrom.id, false, tpForm),
    inpTo = Hafas('#' + this.Controller.TP.inpTo.id, false, tpForm),
    chksBox = Hafas('.lyr_formCheckboxLabel', tpForm),
    submitBtn = Hafas('#HFS_TPSearchButton', false, tpForm),
    inputsArr = [inpFrom, inpTo],
    keysCodeArr = ['NumpadEnter', 'Enter', 'Space'],
    _me = this;

    // From and To EventListener
    inputsArr.forEach(function (inpt) {
      inpt.addEventListener("focus", function () {
        this.value = '';
      });
      inpt.addEventListener("blur", function () {
        if (_me.Controller.TP['inp' + this.id].activeLoc !== null && this.value === '') {
          this.value = _me.Controller.TP['inp' + this.id].activeLoc.name;
        }
        Hafas.bind(_me.Controller.TP.onFormularChange, _me)();
      });
    });

    submitBtn.addEventListener('click', function () {
      Hafas.bind(_me.Controller.TP.updateUrlParameters, _me)();
    })
    // Checkbox Label EventListener
    chksBox.forEach(function (chkBox) {
      chkBox.addEventListener('keydown', function (e) {
        var keyCode = e.code,
        triggerInpt = this.querySelector('input');
        if (keysCodeArr.indexOf(keyCode) > 0) {
          e.preventDefault();
          triggerInpt.click();
        }
      });
    });

  },
  updateUrlParameters: function () {
    var formData = this.Controller.TP.instance.data.query;
    var UrlParams = 'start=1&';
    if (formData.depLocL != null && formData.depLocL.length > 0) {
      UrlParams += 'REQ0JourneyStopsS0G=' + encodeURIComponent(formData.depLocL[0].name) + '&';
      UrlParams += 'REQ0JourneyStopsS0ID=' + encodeURIComponent(formData.depLocL[0].lid) + '&';
    }
    if (formData.arrLocL != null && formData.arrLocL.length > 0) {
      UrlParams += 'REQ0JourneyStopsZ0G=' + encodeURIComponent(formData.arrLocL[0].name) + '&';
      UrlParams += 'REQ0JourneyStopsZ0ID=' + encodeURIComponent(formData.arrLocL[0].lid) + '&';
    }

    if (!formData.returnEnabled) {
      UrlParams += 'journey_mode=single&';
    } else {
      UrlParams += 'journey_mode=return&';
    }
    UrlParams += 'REQ0JourneyDate=' + Hafas.Util.date.encodeURIHciDateString(formData.outDate,true) + '&';
    UrlParams += 'REQ1JourneyDate=' + Hafas.Util.date.encodeURIHciDateString(formData.retDate,true) + '&';
    UrlParams += 'REQ0JourneyTime=' + getIRTime(Hafas("#HFS_OutPeriodSelect").value) + '&';
    UrlParams += 'REQ1JourneyTime=' + getIRTime(Hafas("#HFS_RetPeriodSelect").value) + '&';

    for (var i in Hafas.Config.TP.passengersType) {
      var passengerType = Hafas.Config.TP.passengersType[i];
      var passengerTypeOption = formData.passangerOptions[passengerType];
      var passengerTypeUrlParam = "";
      var passengerTypeUrlPrefix = '';
      if (passengerTypeOption.length > 0) {
        var wheelchairUserCount = passengerTypeOption.filter(function(item) {
          return item.wheelchairUser === 1;
        }).length;
        switch (passengerType) {
          case 'adult':
            passengerTypeUrlPrefix = 'Number_';
            passengerTypeUrlParam = 'adults';
          break;
          case 'child':
            passengerTypeUrlPrefix = 'Number_';
            passengerTypeUrlParam = 'children';
          break
          case 'student':
            passengerTypeUrlPrefix = 'Number_';
            passengerTypeUrlParam = 'students';
          break;
          case 'freeTravelPass':
            passengerTypeUrlParam = 'free-travel-pass-adults';
          break;
          case 'reservationOnly':
            passengerTypeUrlParam = 'seat-only-adults';
          break;
          default:
        }
        UrlParams += passengerTypeUrlPrefix + passengerTypeUrlParam + '=' + passengerTypeOption.length + '&';
        if (wheelchairUserCount > 0) {
          UrlParams += 'wheelchair-' + passengerTypeUrlParam +'=' +wheelchairUserCount+'&';
        }
      }
    }

    if (formData.useBikeFilter) {
      UrlParams += 'bicycle-availability=on&';
    }
    UrlParams += 'language=' + Hafas.Config.currLangObj.lang;

    history.replaceState(null, null, "?" + UrlParams);
    function getIRTime(value) {
      switch (value) {
        case "0":
          return "NOW";
        case "1":
          return "allday";
        case "2":
          return "before10am";
        case "3":
          return "9am";
        case "4":
          return "2pm";
        case "5":
          return "6pm";
        default:
          return 0;
      }
    }

  },
  setLocation: function (type, location) {
    this.Controller.TP.instance.setLocation(type, location);
    if (type == "dep")
      this.Controller.TP.inpFrom.setLocation(location);
    else if (type == "arr")
      this.Controller.TP.inpTo.setLocation(location);
  },
  setDate: function (hcidate) {
  },

  setExternJnyOptions: function (type, value) {

    var that = this.Controller.TP;

    function formatDate(name) {
      var sep = ".";
      if (name.indexOf("/") !== -1) { // IrishRail übergibt ein anderen Datumsformat mit / als Trennezeichen.
        sep = "/";
      }
      var v = name.split(sep);
      return v[2] + v[1] + v[0];
    }

    /**
     * Es darf kein Datum vor heute verwendet werden.
     * @param hciDate
     * @returns {number|*}
     */
    function checkDate(hciDate) {
      var jsDate = Hafas.Util.date.hciDate2jsDate(hciDate);
      if (Hafas.Util.date.isBeforeToday(jsDate)) {
        var now = Hafas.Util.date.getServerTime();
        return Hafas.Util.date.jsDate2hciDate(now).hciDate;
      } else {
        return hciDate;
      }
    }

    var formatIRTime = function (name) {
      switch (name) {
        case "0":
        case "now":
          return 0;
        case "00":
        case "allday":
          return 1;
        case "9":
        case "before10am":
          return 2;
        case "14":
        case "9am":
          return 3;
        case "18":
        case "2pm":
          return 4;
        case "22":
        case "6pm":
          return 5;
        default:
          return 0;
      }
    };

    var passengerOptions = this.Controller.TP.instance.getPassangerOptions();
    try {
      switch (type) {
        case "outDate":
          var date = checkDate(formatDate(value));
          Hafas.bind(this.Controller.TP.actions.onChangeOutDate, this)(date);
          this.Controller.TP.outDatePicker.setDate(date);
          this.Controller.TP.outDatePicker.updateViews();
          this.Controller.TP.outDatePicker.updateDisplay();
          break;
        case "retDate":
          var date = checkDate(formatDate(value));
          Hafas.bind(this.Controller.TP.actions.onChangeRetDate, this)(date);
          this.Controller.TP.retDatePicker.setDate(date);
          this.Controller.TP.retDatePicker.updateViews();
          this.Controller.TP.retDatePicker.updateDisplay();
          break;
        case "Number_adults":
          passengerOptions.setAdults(parseInt(value, 10));
          break;
        case "Number_children":
          passengerOptions.setChilds(parseInt(value, 10));
          break;
        case "Number_students":
          passengerOptions.setStudents(parseInt(value, 10));
          break;
        case "free-travel-pass-adults":
          passengerOptions.setFreeTravelPass(parseInt(value, 10));
          for (var i = 0; i < passengerOptions.freeTravelPass.length; i++) {
            passengerOptions.freeTravelPass[i].redtnCard = 2;
          }
          break;
        case "seat-only-adults":
          passengerOptions.setReservationOnly(parseInt(value, 10));
          for (var i = 0; i < passengerOptions.reservationOnly.length; i++) {
            passengerOptions.reservationOnly[i].redtnCard = 1;
          }
          break;
        case "journey_mode":
          if (value === "single") {
            Hafas("#HFS_ReturnRadioOff").checked = true;
            Hafas.bind(this.Controller.TP.actions.onChangeReturn, this)(false);
          } else {
            Hafas("#HFS_ReturnRadioOn").checked = true;
            Hafas.bind(this.Controller.TP.actions.onChangeReturn, this)(true);
          }
          break;
        case "outTime_select":
          var select = Hafas("#HFS_OutPeriodSelect");
          select.value = formatIRTime(value);
          Hafas.ps.pub('tp/onPerdiodChange', [select.id, select.value]);
          break;
        case "retTime_select":
          var select = Hafas("#HFS_RetPeriodSelect");
          select.value = formatIRTime(value);
          Hafas.ps.pub('tp/onPerdiodChange', [select.id, select.value]);
          break;
        case "wheelchair-adults":
          setWheelchairUser("adult", value);
          break;
        case "wheelchair-children":
          setWheelchairUser("child", value);
          break;
        case "wheelchair-students":
          setWheelchairUser("student", value);
          break;
        case "wheelchair-free-travel-pass-adults":
          setWheelchairUser("freeTravelPass", value);
          break;
        case "wheelchair-seat-only-adults":
          setWheelchairUser("reservationOnly", value);
          break;

        case "bicycle-availability":
          if (value === "on") {
            Hafas("#HFS_setBikeFilter").checked = true;
            Hafas.ps.pub('/tp/setBikeFilter', [true]);
          }
      }
      function setWheelchairUser(type, value) {
        var passengerTypeOption = passengerOptions[type]
        for (var i = 0; i < value; i++) {
          if (passengerTypeOption.length < value) {
            passengerOptions.setPassenger(type, passengerTypeOption.length + 1);
          }
          if (i < passengerTypeOption.length) {
            passengerTypeOption[i].wheelchairUser = 1;
          }
        }
        Hafas("#TP_passengersWheelchair").addClassName('lyr_selected');
      }
      Hafas.bind(this.Controller.TP.actions.updatePassengerOptionsDisplay, this)(passengerOptions);

    } catch (e) {
      console.warn("Error by reading URL Parameter!");
    }

  },

  postForm: function (data) {
    if (typeof data.ev != 'undefined')
      data.ev.preventDefault();

    //Wird die Suche durch extere Parameter gestartet.
    data.searchFromExternal = !!data.searchFromExternal; // Strawberry 1.6.0

    // close date time picker if it is open
    //this.Controller.TP.dateTimePicker.cancel();

    // validate time fields
    var timeInputs = Hafas('[data-app-tp="time"]', true),
    i = 0,
    len = timeInputs.length;
    for (i; i < len; i++) {
      var input = timeInputs[i];
      Hafas.ps.pub('/tp/validateTime', [input]);
    }


    this.Controller.TP.validate(['From', 'To'], Hafas.bind(function () {
      var form = Hafas.Core.newType("hafasValidation", {
        form: data.form
      });


      // If input are valid -> proceed with connection search
      if (form.valid) {
        // show loadingImage and set Button to disabled
        if (data.form.elements.submitTPForm) {
          Hafas.bind(this.Controller.App.triggerLoadingImage, this)(data.form.elements.submitTPForm);

        }

        // Reset cluster
        for (var c = 0; c < Hafas.Config.TP.cluster.length; c++) {
          if (typeof Hafas.Config.TP.cluster[c].requested != 'undefined') {
            delete Hafas.Config.TP.cluster[c].requested;
          }
        }

        // Reset Selected Tickets
        this.Controller.TP.ticketSelection.clear();
        //Hafas.bind(this.Controller.TP.hideTicketBannerDetails, this)();
        Hafas.bind(this.Controller.TP.renderTicketBanner, this)();

        // Search connection

        this.Controller.TP.instance.search({
          ptCallback: Hafas.bind(this.Controller.TP.showResultOverview, this)
        });

        // this.Controller.TP.addToSearchHistory();

        // Tracking
        Hafas.ps.pub('/tracking/event/connection-request', [{
          typ: 'event',
          key: 'connection-request',
          data: {type: 'initial'}
        }]);
        Hafas.ps.pub('/tracking/event/tripplanner-request-triggered', [{
          typ: 'event',
          key: 'tripplanner-request-triggered',
          data: {type: 'initial'}
        }]);

        // remove instances of connectionmaps (-> classic Version)
        this.Controller.Map.connectionMaps = [];

        var button = Hafas("#HFS_TPSearchButton");
        if (button) {
          button.disabled = true;
          button.addClassName("lyr_noChanges");
        }

        Hafas.bind(this.Controller.TP.showWaitView, this)(Hafas.Modules.i18n.get('TP.index.t_N_WaitSearchConnection'));

      }
    }, this));

    if (!Hafas.Config.showOptionsOnInit) {
      Hafas.ps.pub('/GUI/tabs/closeAll');
      Hafas.ps.pub('/GUI/options/closeAll');
    }
    Hafas.ps.pub('/app/events/renderDone');
    return false;
  },
  searchReconstruction: function (data, type) {
    Hafas.bind(this.Controller.TP.showWaitView, this)(Hafas.Modules.i18n.get('ShareTrip.t_N_WaitForRecon')); // Strawberry 1.6.0
    this.Controller.TP.instance.reconstruct(data, type);
  },
  showWaitView: function (waitText) {
    Hafas("#HFS_TpResult").innerHTML = Hafas.Modules.Render.renderTemplate("TP_TplWaitView", {waitText: waitText});
    Hafas.ps.pub('/app/events/resize');
  },
  addToSearchHistory: function () {
    if (Hafas.Config.Switches.useFavorites) {
      var depLoc = this.main.Controller.TP.instance.getLocation('dep');
      var arrLoc = this.main.Controller.TP.instance.getLocation('arr');
      if (depLoc != null && arrLoc != null) {
        var depLocHistory = {
          name: depLoc.name,
          lid: depLoc.lid
        };
        var arrLocHistory = {
          name: arrLoc.name,
          lid: arrLoc.lid
        };
        if (Hafas.Config.Switches.useFavorites && !Hafas.Config.Favorites.addLocationOnSuggest) {
          depLocHistory.prod = Hafas.Modules.Suggest.getSuggestInstanceById('From').productRef;
          arrLocHistory.prod = Hafas.Modules.Suggest.getSuggestInstanceById('To').productRef;
          this.main.Controller.Favorites.instance.addLocation(depLocHistory, 'History');
          this.main.Controller.Favorites.instance.addLocation(arrLocHistory, 'History');
        }
        var chgOptTxt = this.main.Controller.TP.options.getOptionTexts();
        var model = {
          dep: depLocHistory,
          arr: arrLocHistory,
          opt: {}
        };
        var hashStr = "";
        if (Hafas.Config.Favorites.storeQueryOptions && chgOptTxt.infoText != "") {
          var modifiedModel = this.main.Controller.TP.options.getModifiedModel();
          hashStr = Hafas.Util.createHash.hex_md5(depLocHistory.name + arrLocHistory.name + chgOptTxt.infoText);
          // console.log("+++ create Hash +++ " + hashStr);
          model.opt = {
            txt: chgOptTxt.infoText,
            mod: modifiedModel,
            hash: hashStr,
            version: Hafas.Config.Options.version // Strawberry 1.5
          };
        } else {
          hashStr = Hafas.Util.createHash.hex_md5(depLocHistory.name + arrLocHistory.name);
          model.opt.hash = hashStr;
          model.opt.version = null; // Strawberry 1.5
        }
        this.main.Controller.Favorites.instance.addConnection(model, 'History');
      }
    }
  },
  validate: function (items, callback) {

    var tpController = this.main.Controller.TP;
    var resolvedCount = 0;
    var itemLength = items.length;

    function resolveMe() {
      resolvedCount++;

      if (resolvedCount === itemLength) {
        callback();

      }
    }

    for (var i = 0; i < itemLength; i++) {
      var itemId = items[i];
      var locationId;

      switch (itemId) {
        case 'From':
          locationId = 'dep';
          break;
        case 'To':
          locationId = 'arr';
          break;
        default:
          resolveMe();
          continue;
      }

      var location = tpController.instance.getLocation(locationId);
      var input = tpController['inp' + itemId];
      var inputText = input.getInputText();
      var textLength = inputText.length;


      if (textLength == 0) {
        tpController.instance.setLocation(locationId, null);
      }

      if ((textLength > 0) && (location == null || inputText != location.name)) {

        input.validateLocation(true, resolveMe);

      } else
        resolveMe();
    }
  },

  // Füllt eine Select mit Optionen für die Auswahl der Fahrgäste
  createPassangerCountOptions: function (type, currentCount) {
    var list = [];

    function getLabel(type, c) {
      if (c === 1) {
        switch (type) {
          case "E":
            return Hafas.Modules.i18n.get("TP.index.t_N_Adult");
          case "K":
            return Hafas.Modules.i18n.get("TP.index.t_N_Child");
          case "S":
            return Hafas.Modules.i18n.get("TP.index.t_N_Student");
        }
      } else {
        switch (type) {
          case "E":
            return Hafas.Modules.i18n.get("TP.index.t_N_Adults");
          case "K":
            return Hafas.Modules.i18n.get("TP.index.t_N_Childs");
          case "S":
            return Hafas.Modules.i18n.get("TP.index.t_N_Students");
        }
      }

    }

    for (var i = 0; i < Hafas.Config.TP.maxPassangerCount; i++) {
      list.push({
        value: i,
        selected: currentCount === i,
        label: i + " " + getLabel(type, i)
      })
    }

    return list;
  },

  showResultOverview: function (tripResult, options) {

    if (Object.keys(tripResult).length === 0){
        return;
      }

    // Strawberry 1.5: Diverse Korrekturen in Verbindung mit der Rekonstruktion und dem History Modul, au�erdem werden die Bl�tter Buttons bei Aufruf mit Rekonstruktionskontext nicht mehr angezeigt
    if (Hafas.Modules.History) {
      if (tripResult.flags.isReconstruction) { // Strawberry 1.6.0
        Hafas.Modules.History.addOrUpdateData("TP", "reconstruction", tripResult);
      } else {
        Hafas.Modules.History.addOrUpdateData("TP", "overview", tripResult);
      }
    }

    this.Controller.TP.currentView = "overview";
    this.Controller.TP.currentTripResult = tripResult;
    this.Controller.TP.currentConnectionData = {};

    this.Controller.TP.createGlobalTariffInfo(tripResult.outConnections || [], tripResult.retConnections || []);
    var html = Hafas.Modules.Render.renderTemplate("TP_TplResultOverview", {tripResult: tripResult}, {
      global: {view: this.Controller.TP.currentView}
    });

    Hafas("#HFS_TpResult").innerHTML = html;
    // is defined in classic-Version GUI-Functions
    Hafas.ps.pub('/GUI/window/scrollTo', ['top']);

    if (tripResult.outConnections.length > 0) {
      var outDateChooser = new Hafas.Modules.gui.DaySelector("HFS_TpOutDateChooser", tripResult.query.outDate, "out", tripResult.outCalendarFareL);
      outDateChooser.render();
    }


    if (tripResult.query.returnEnabled) {
      if (tripResult.retConnections.length > 0) {
        var retDateChooser = new Hafas.Modules.gui.DaySelector("HFS_TpRetDateChooser", tripResult.query.retDate, "ret", tripResult.retCalendarFareL, tripResult.query.outDate);
        retDateChooser.render();
      }
    }
    if (tripResult.status !== 'error') {
      Hafas.bind(this.Controller.TP.renderTicketBanner, this)();
    } else {
      Hafas("#HFS_TpPriceBannerHolder").innerHTML = "";
    }
    Hafas.bind(this.Controller.TP.postRenderOverview, this)();

    // Track
    Hafas.ps.pub('/tracking/screen/connection-overview', [{typ: 'screen', key: 'connection-overview'}]);
    Hafas.ps.pub('/tracking/screen/tripplanner-overview', [{typ: 'screen', key: 'tripplanner-overview'}]);


  },

  postRenderOverview: function () {
    var tripResult = this.Controller.TP.currentTripResult;
    if (document.selection) {
      document.selection.empty();
    } else if (window.getSelection) {
      window.getSelection().removeAllRanges();
    }
    var connection;

    for (var i = 0; i < tripResult.outConnections.length; i++) {
      connection = tripResult.outConnections[i];
      this.Controller.TP.currentConnectionData[connection.cid] = {
        connection: connection,
        detailsOpen: false,
        dir: "out"
      };
    }

    if (tripResult.retConnections.length) {
      for (var i = 0; i < tripResult.retConnections.length; i++) {
        connection = tripResult.retConnections[i];
        this.Controller.TP.currentConnectionData[connection.cid] = {
          connection: connection,
          detailsOpen: false,
          dir: "ret"
        };
      }
    }

    var isSearchChanged = false;

    Hafas("#HFS_TPSearchButton").blur();
    if (connection == undefined) {
      Hafas("#HFS_TPOverviewResults .lyr_error").focus();
      return;
    } else {
      var jsDate = Hafas.Util.date.hciDate2jsDate(connection.date),
      rsOnlyDate = Hafas.Util.date.getDayNameFromDate(jsDate, "long") + ' ' + jsDate.getDate() + ' ' + Hafas.Util.date.getMonthNameFromDate(jsDate, "long"),
      srMeg = Hafas.Modules.i18n.get('TP.results.textual.jny.t_N_connectionTxt001') + ' ' +
      connection.dep.locResolved.name + Hafas.Modules.i18n.get('TP.results.textual.jny.t_N_connectionTxt002') + ' ' +
      connection.arr.locResolved.name + Hafas.Modules.i18n.get('TP.results.textual.jny.t_N_connectionTxt003') + rsOnlyDate;
      //Hafas("#HFS_TPOverviewResultsNotice").innerHTML = srMeg;
      Hafas.Modules.a11y.Announce.polite(Hafas.Modules.Render.renderTemplate("#HFS_TPOverviewResultsNotice", {ally: srMeg}));
    }
    this.Controller.TP.connection = connection;
    pageScroll();

    function pageScroll() {
      var top = 400;
      if (Hafas('#HFS_WebApp').classList.contains('layout-small')) {
        top = 580;
      }
      document.body.scrollTop = top;
      document.documentElement.scrollTop = top;
    }
  },

  createGlobalTariffInfo: function (outConnections, retConnections) {
    var globalTariffInfo = {
      count: 0,
      low: {status: "none"},
      semiFlex: {status: "none"},
      flex: {status: "none"},
      firstClass: {status: "none"}
    };
    for (var i = 0; i < outConnections.length; i++)
      this.addTariffToGlobalInfo(globalTariffInfo, outConnections[i].resolvedTariffs);
    for (var i = 0; i < retConnections.length; i++)
      this.addTariffToGlobalInfo(globalTariffInfo, retConnections[i].resolvedTariffs);
    return globalTariffInfo;
  },

  addTariffToGlobalInfo: function (globalTariffInfo, tariffSet) {
    if (tariffSet === undefined) {
      return;
    }
    if (tariffSet.low !== null) {
      if (globalTariffInfo.low.status == "none") {
        globalTariffInfo.count++;
        globalTariffInfo.low.status = "ok";

      }
    }
    if (tariffSet.semiFlex !== null) {
      if (globalTariffInfo.semiFlex.status == "none") {
        globalTariffInfo.count++;
        globalTariffInfo.semiFlex.status = "ok";

      }
    }
    if (tariffSet.flex !== null) {
      if (globalTariffInfo.flex.status == "none") {
        globalTariffInfo.count++;
        globalTariffInfo.flex.status = "ok";

      }
    }
    if (tariffSet.firstClass !== null) {
      if (globalTariffInfo.firstClass.status == "none") {
        globalTariffInfo.count++;
        globalTariffInfo.firstClass.status = "ok";

      }
    }
    tariffSet.globalTariffInfo = globalTariffInfo;
  },

  renderTicketBanner: function () {

    if (this.Controller.TP.currentTripResult && this.Controller.TP.currentTripResult.query) {
      this.Controller.TP.ticketSelection.setReturnState(this.Controller.TP.currentTripResult.query.returnEnabled);
    } else {
      Hafas("#HFS_TpPriceBannerHolder").innerHTML = "";
      return;
    }
    this.Controller.TP.ticketSelection.passengersPriceDetailsResolved = this.Controller.TP.updateTicketBannerPassengersPrice(this.Controller.TP.ticketSelection);
    var model = {
      ticketSelection: this.Controller.TP.ticketSelection
    };
    var html = Hafas.Modules.Render.renderTemplate("TP_TplConnectionPriceBanner", model);
    Hafas("#HFS_TpPriceBannerHolder").innerHTML = html;

    if (this.Controller.TP.ticketSelection.areDetailsOpen) {
      Hafas.bind(this.Controller.TP.toggleTicketBannerDetails, this)();
    }
  },

  updateTicketBannerPassengersPrice: function (ticketSelection) {
    return  {
      outTicketPassengersPrice: getPassengersPrice(ticketSelection && ticketSelection.selectedOutwardTicket && ticketSelection.selectedOutwardTicket.addDataResolve && ticketSelection.selectedOutwardTicket.addDataResolve.passengerList),
      retTicketPassengersPrice: getPassengersPrice(ticketSelection && ticketSelection.selectedReturnTicket && ticketSelection.selectedReturnTicket.addDataResolve && ticketSelection.selectedReturnTicket.addDataResolve.passengerList)
    };

    function getPassengersPrice(passengersList) {
      if(!passengersList){
        return [];
      }

      for (var i in passengersList) {
        passengersList[i].label = "TP.priceBanner.t_N_" + passengersList[i].type;
        passengersList[i].totalPrice = (passengersList[i].price !== undefined ? passengersList[i].price : 0) * passengersList[i].amount;

        if (passengersList[i].type === "adult") {

          if (passengersList[i].freeTravelPass){
            passengersList[i].label = "TP.priceBanner.t_N_freeTravelPass";
          }
          if (passengersList[i].seatOnly){
            passengersList[i].label = "TP.priceBanner.t_N_reservationOnly";
          }
        }
      }

      return passengersList;
    }
  },

  backToTop: function () {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    Hafas.bind(this.Controller.TP.toggleTicketBannerDetails, this)();
  },

  toggleTicketBannerDetails: function () {
    if (this.Controller.TP.ticketSelection.areDetailsOpen) {
      Hafas.bind(this.Controller.TP.hideTicketBannerDetails, this)();
    } else {
      Hafas.bind(this.Controller.TP.showTicketBannerDetails, this)();
    }

  },

  showTicketBannerDetails: function () {

    this.Controller.TP.ticketSelection.areDetailsOpen = true;
    Hafas.Util.gui.setVisibility(Hafas("#HFS_PriceButtonDetails_Panel"), true);
    Hafas("#HFS_PriceButtonDetails_Panel").setAttribute("aria-expanded", true);
    Hafas("#HFS_PriceButtonDetails_Tab").setAttribute("aria-expanded", true);
  },

  hideTicketBannerDetails: function () {
    this.Controller.TP.ticketSelection.areDetailsOpen = false;
    Hafas.Util.gui.setVisibility(Hafas("#HFS_PriceButtonDetails_Panel"), false);
    Hafas("#HFS_PriceButtonDetails_Panel").setAttribute("aria-expanded", false);
    Hafas("#HFS_PriceButtonDetails_Tab").setAttribute("aria-expanded", false);
  },
  /******************************************************************************************************************************************/
  /******************************************************************************************************************************************/

  /**
   * Get the calculated hash for the current connection
   * @param depLocation
   * @param arrLocation
   */
  getCurrentConnectionHash: function (depLocationName, arrLocationName) {
    var optionText = this.Controller.TP.options.getOptionTexts().infoText;
    var currentConnStr = depLocationName + arrLocationName;
    if (Hafas.Config.Favorites.storeQueryOptions && optionText != "") {
      currentConnStr += optionText;
    }
    var currentConnHash = Hafas.Util.createHash.hex_md5(currentConnStr);
    return currentConnHash;
  },

  toggleDetails: function (params) {

    var $container = Hafas("#HFS_ConnectionId_" + params.cid);
    var connection = Hafas.Modules.Render.objectKeeper.get(params.connectionKey),
    model = {
      connection: connection,
      lastSec: connection.secL[connection.secL.length - 1],
      firstSec: connection.secL[0]
    };

    var detailsButton = Hafas(".lyr_showDetailsButton", false, $container);


    if (!$container.classList.contains('js_open')) {
      this.Controller.TP.currentConnectionData[connection.cid].detailsOpen = true;
      var html = Hafas.Modules.Render.renderTemplate("TP_TplDetail", model);
      Hafas('#HFS_TpConnectionDetailsHolder_' + connection.cid).innerHTML = html;
      $container.addClassName("js_open");
      Hafas('#HFS_ConnectionId_' + connection.cid + ' .lyr_connectionAtrributes').removeClassName('js_hide');
      detailsButton.setAttribute("aria-expanded", "true");

    } else {
      this.Controller.TP.currentConnectionData[connection.cid].detailsOpen = false;
      $container.removeClassName("js_open");
      Hafas('#HFS_ConnectionId_' + connection.cid + ' .lyr_connectionAtrributes').addClassName('js_hide');
      Hafas("#HFS_TpConnectionDetailsHolder_" + connection.cid).innerHTML = "";
      detailsButton.setAttribute("aria-expanded", "false");
    }

  },


  showDetails: function (params) {
    var connection = Hafas.Modules.Render.objectKeeper.get(params.connectionKey);
    var model = {
      connection: connection,
      lastSec: connection.secL[connection.secL.length - 1]
    };

    this.Controller.TP.currentConnectionData[connection.cid].detailsOpen = true;
    var html = Hafas.Modules.Render.renderTemplate("TP_TplDetail", model);
    Hafas('#HFS_TpConnectionDetailsHolder_' + connection.cid).innerHTML = html;
    Hafas("#HFS_ConnectionId_" + connection.cid).addClassName("js_open");
  },

  hideDetails: function (params) {
    var connection = Hafas.Modules.Render.objectKeeper.get(params.connectionKey);
    this.Controller.TP.currentConnectionData[connection.cid].detailsOpen = false;
    Hafas("#HFS_ConnectionId_" + connection.cid).removeClassName("js_open");
    Hafas("#HFS_TpConnectionDetailsHolder_" + connection.cid).innerHTML = "";
  },

  toggleInterStops: function (params) {

    var $container = Hafas("#HFS_TPSection_" + params.cid + "_" + params.secIndex);

    if ($container.classList.contains('js_close_interStops')) {
      $container.classList.add('js_show_interStops');
      $container.classList.remove('js_close_interStops');
      params.trigger.setAttribute('aria-expanded', 'true')
    } else if ($container.classList.contains('js_show_interStops')) {
      $container.classList.add("js_close_interStops");
      $container.classList.remove("js_show_interStops");
      params.trigger.setAttribute('aria-expanded', 'false')
    }

  },

  hideInterStops: function (params) {
    //this.currentConnectionData[params.cid].showInterStops = false;
    Hafas("#HFS_TPSection_" + params.cid + "_" + params.secIndex).removeClassName("js_show_interStops");
    Hafas("#HFS_TPSection_" + params.cid + "_" + params.secIndex).addClassName("js_close_interStops");
  },

  printSearchLink: function () {
    console.log(this.Controller.TP.instance.createSearchLink());
  },

  printReconstructionLink: function () {
    var selectedConnection = this.Controller.TP.selectedConnection;
    if (selectedConnection == null) {
      console.warn("selectedConnection is null!");
      return;
    }
    console.log(Hafas.Core.getWebAppBasePath() + "?ctxRecon=" + encodeURIComponent(selectedConnection.ctxRecon));
  },

  printSelectedConnection: function () {
    var selectedConnection = this.Controller.TP.selectedConnection;
    if (selectedConnection == null) {
      console.warn("selectedConnection is null!");
      return;
    }
    // console.log(selectedConnection);
  },

  showShareLink: function () {
    var url = this.Controller.TP.instance.createSearchLink();
    var model = {
      url: url,
      clearUrl: decodeURIComponent(url)
    }

    var html = Hafas.Modules.Render.renderTemplate("TP_ShareLinkOverlay", {renderInfo: model});
    Hafas.Core.newType("HafasOverlay", {
      id: "ShareLinkOverlay",
      app: this,
      title: "Share link",
      outputHTML: html,
      callback: function () {
      }
    });
  },

  closeView: function (histData) {
    // console.log("+++ close view +++", histData);
    switch (histData.view) {
      case "index":
      case "reconstruction":
      case "reconstructionError":
      case "overview":
        break;
      case "details":
        if (Hafas.Config.TP.unifiedPlanner.show) {
          Hafas.ps.pub('/GUI/form/show', [{appcontext: this.appContext}]);
        }
        Hafas.ps.pub('/GUI/results/details/hide', [{}]);
        Hafas.bind(this.Controller.TP.cleanMap, this)();
        break;
    }
  },

  restoreView: function (histData) {
    // Guard against missing or empty data object to prevent errors when restoring view state
    // (e.g., when navigating via browser back button in SPA mode)
    if(!histData.data || Object.keys(histData.data).length === 0) {
      return;
    }
    // console.log("+++ restore view +++", histData);
    var view = histData.view;
    switch (view) {
      case "index":
        Hafas.bind(this.Controller.TP.renderIndex, this)(histData.data);
        break;
      case "overview":
        Hafas.bind(this.Controller.TP.showResultOverview, this)(histData.data);
        break;
      case "reconstruction":
        Hafas.bind(this.Controller.TP.showResultOverview, this)(histData.data, {});
        break;
      case "reconstructionError":
        Hafas.bind(this.Controller.TP.showReconstructionError, this)(histData.data);
        break;
    }
  },

  cleanup: function () {
    /* TP relevante Karteninhalte l?schen */
    this.Controller.TP.currentOutConnections = [];
    this.Controller.TP.currentRetConnections = [];
    this.Controller.TP.selectedConnection = null;
    this.Controller.TP.currentView = null;
  },

  getConnectionById: function (cid) {
    if (this.Controller.TP.currentTripResult === null) {
      return null;
    }
    var list = this.Controller.TP.currentTripResult.outConnections;
    for (var i = 0; i < list.length; i++) {
      if (list[i].cid === cid)
        return {dir: "out", connection: list[i]};
    }

    list = this.Controller.TP.currentTripResult.retConnections;
    for (i = 0; i < list.length; i++) {
      if (list[i].cid === cid)
        return {dir: "ret", connection: list[i]};
    }
    return null;
  },

  unselectAllTicketsOfDir: function (dir) {
    var list;
    var buttonTypes = Object.keys(Hafas.model.connection.TariffItem.Types);
    if (dir === "out") {
      list = this.Controller.TP.currentTripResult.outConnections;
    } else {
      list = this.Controller.TP.currentTripResult.retConnections;
    }
    if (list === null) {
      return;
    }
    for (var i = 0; i < list.length; i++) {
      var connection = list[i];
      var descHolder = Hafas("#HFS_TpConnectionPriceDesc_" + connection.cid);
      if (descHolder) {
        descHolder.removeClassName("lyr_show");
        descHolder.removeClassName("lyr_selected_firstClass");
        descHolder.innerHTML = "";
      }
      for (var x = 0; x < buttonTypes.length; x++) {
        var button = Hafas("#HFS_TicketButton_" + buttonTypes[x] + "_" + connection.cid);
        if (button) {
          button.removeClassName("lyr_selected");
          var selectHint = Hafas(".lyr_selectedTicketHint", false, button);
          selectHint.setAttribute("aria-hidden", true);
          var buttonUpgradePrice = Hafas("#HFS_TicketButton_" + buttonTypes[x] + "_" + connection.cid + " .lyr_upgradePriceInner");
          if (buttonUpgradePrice !== null)
            buttonUpgradePrice.removeAttribute("style");
        }
      }

    }
  },
  selectAllAvailableTicketsOfDate: function (result) {
    var compareObj = {
      targetDir: 'ret',
      currCon: {
        pltform: 'arr',
        time: 'aTimeS'
      },
      TripResults: {

        pltform: 'dep',
        time: 'dTimeS'
      }

    };

    // if retern connection
    if (result.dir === 'ret') {
      compareObj = {
        targetDir: 'out',
        currCon: {
          pltform: 'dep',
          time: 'dTimeS'
        },
        TripResults: {
          pltform: 'arr',
          time: 'aTimeS'
        }
      };
    }
    var selectedConnDate = Hafas.Core.newType("hafasTime", {
      date: result.connection.date,
      time: result.connection[compareObj.currCon.pltform][compareObj.currCon.time]
    });

    var connectionData = this.Controller.TP.currentTripResult[compareObj.targetDir + 'Connections'];

    for (var i = 0; i < connectionData.length; i++) {
      Hafas('#HFS_ConnectionId_' + connectionData[i].cid).removeClassName('lyr_notAvailableConnection')
    }
    var notAvailableConnectionIds = []
    for (var c = 0; c < connectionData.length; c++) {
      var conn = connectionData[c];
      var connDate = Hafas.Core.newType("hafasTime", {
        date: conn.date,
        time: conn[compareObj.TripResults.pltform][compareObj.TripResults.time]
      });
      if (selectedConnDate.jsDate > connDate.jsDate) {
        notAvailableConnectionIds.push(conn.cid)
      }

    }

    for (var n = 0; n < notAvailableConnectionIds.length; n++) {
      Hafas('#HFS_ConnectionId_' + notAvailableConnectionIds[n]).addClassName('lyr_notAvailableConnection');
    }
    this.Controller.TP.ticketSelection.firstAvailableConnection = 'HFS_ConnectionId_' + notAvailableConnectionIds[notAvailableConnectionIds.length - 1]
  },

  selectTicketInGui: function (cid, ticket) {

    var ticketDescHolder = Hafas("#HFS_TpConnectionPriceDesc_" + cid);
    if (ticketDescHolder) {
      ticketDescHolder.addClassName("lyr_show");
      ticketDescHolder.innerHTML = Hafas.Modules.Render.renderTemplate("TP_TplFareDescription_" + ticket.type, {});
      if (ticket.type === Hafas.model.connection.TariffItem.Types.firstClass) {
        ticketDescHolder.addClassName("lyr_selected_firstClass");
      }
    }


    Hafas.Modules.a11y.Announce.polite(Hafas.Modules.Render.renderTemplate("TP_TplAtomTicketSelectedAnnounce", {ticket: ticket}));
    var button = Hafas("#HFS_TicketButton_" + ticket.type + "_" + cid);

    if (button) {
      button.addClassName("lyr_selected");
      Hafas(".lyr_selectedTicketHint", false, button).setAttribute("aria-hidden", false);
    }
  },

  upgradePricesGui: function (tariffSet, ticket, ticketId) {

    var tariffItemsType = Object.keys(Hafas.model.connection.TariffItem.Types);
    var availableTickets = {};

    for (var i in tariffItemsType) {

      if (tariffSet[tariffItemsType[i]] !== null && tariffSet[tariffItemsType[i]].type === ticket.type) {
        var currentTicketIdx = i;
      }
      if (tariffSet[tariffItemsType[i]] !== null && i > currentTicketIdx && currentTicketIdx !== undefined) {
        availableTickets[tariffItemsType[i]] = tariffSet[tariffItemsType[i]];
      }
    }
    if (Object.keys(availableTickets).length !== 0) {
      for (var i in availableTickets) {

        var ticketGui = document.querySelector("#HFS_TicketButton_" + availableTickets[i].type + "_" + ticketId),
        priceHolder = ticketGui.querySelector(".lyr_priceButtonInner"),
        upgradePriceHolder = ticketGui.querySelector(".lyr_upgradePriceInner"),
        diff = availableTickets[i].price - ticket.price;


        upgradePriceHolder.removeAttribute('aria-hidden');
        priceHolder.querySelector(".lyr_price").setAttribute('aria-hidden', 'hidden');

        upgradePriceHolder.style.zIndex = 1;

        Hafas(".lyr_upgradePrice", false, upgradePriceHolder).setAttribute('aria-hidden', 'hidden');
        Hafas(".lyr_upgradePrice", false, upgradePriceHolder).innerHTML = "+ &euro;" + Hafas.Util.format.money(diff, " ", "1,000.00");
        Hafas(".lyr_srOnly", false, upgradePriceHolder).innerHTML = "+ &euro;" + Hafas.Util.format.money(diff, " ", "1,000.00");
      }
    }
  },

  createBookTicketURL: function () {

    var ticketSelection = this.Controller.TP.ticketSelection;
    var url = "";
    if (ticketSelection.selectedOutwardTicket === null) {
      return null;
    } else {
      url = ticketSelection.selectedOutwardConnection.resolvedTariffs.bookURL + ticketSelection.selectedOutwardTicket.bookURL;
    }

    if (ticketSelection.resultHasReturn) {
      if (ticketSelection.selectedReturnTicket === null) {
        return null;
      } else {
        url += ticketSelection.selectedReturnTicket.bookURL;
      }
    }
    return url;
  },

  onFormularChange: function () {
    var button = Hafas("#HFS_TPSearchButton");
    var fromInp = Hafas('#From')
    var toInp = Hafas('#To')

    if (button) {

      if (fromInp.value.length > 0 && toInp.value.length > 0) {
        button.disabled = false;
        button.removeClassName("lyr_noChanges");
      } else {
        button.disabled = true;
        button.addClassName("lyr_noChanges");
      }
    }
  },

  onCopyShareLinkToClipboard: function () {
    var shareLinkInput = Hafas("#HFS_ShareLinkInput");
    shareLinkInput.disabled = false;
    shareLinkInput.select();
    shareLinkInput.setSelectionRange(0, 99999);

    document.execCommand("copy");

    setTimeout(function () {
      if (window.getSelection) {
        window.getSelection().removeAllRanges();
      }
      shareLinkInput.selectionStart = shareLinkInput.selectionEnd;
      shareLinkInput.disabled = true;
    }, 1000);

  },

  /**
   * clears all input data (including options) and switches back to trip planner
   *
   * @method
   */

  checkSelectedOutwardDate: function (connection) {
    var showError = {};
    var selectedConnDate = Hafas.Core.newType("hafasTime", {
      date: connection.connection.date,
      time: connection.connection.arr.aTimeS
    });
    var returnConn = this.Controller.TP.ticketSelection.selectedReturnConnection;
    if (returnConn !== null) {
      var returnDate = Hafas.Core.newType("hafasTime", {
        date: returnConn.date,
        time: returnConn.dep.dTimeS
      });
      if (selectedConnDate.jsDate >= returnDate.jsDate) {
        showError.status = true;
        showError.msg = Hafas.Modules.i18n.get('TP.results.t_N_ChooseOutwardWarning');
        showError.aIds = Hafas.bind(this.Controller.TP.selectFirstAvailableOutwardTickets, this)(returnDate);
      }
    }
    return showError;
  },

  selectFirstAvailableOutwardTickets: function (returnDepDate) {
    var connectionData = this.Controller.TP.currentTripResult.outConnections;
    var availableConnectionIds = [];
    for (var c = 0; c < connectionData.length; c++) {
      var conn = connectionData[c];
      var connArrDate = Hafas.Core.newType("hafasTime", {
        date: conn.date,
        time: conn.arr.aTimeS
      });
      if (connArrDate.jsDate <= returnDepDate.jsDate) {
        availableConnectionIds.push({cid: conn.cid, con: conn});
      }
    }
    return availableConnectionIds;
  },

  checkSelectedReturnDate: function (connection) {
    var showError = {};
    var selectedConnDate = Hafas.Core.newType("hafasTime", {
      date: connection.connection.date,
      time: connection.connection.dep.dTimeS
    });

    var outwardConn = this.Controller.TP.ticketSelection.selectedOutwardConnection;
    if (outwardConn !== null) {
      var outwardDate = Hafas.Core.newType("hafasTime", {
        date: outwardConn.date,
        time: outwardConn.arr.aTimeS
      });
      if (selectedConnDate.jsDate <= outwardDate.jsDate) {
        showError.status = true;
        showError.msg = Hafas.Modules.i18n.get('TP.results.t_N_ChooseReturnWarning');
        showError.aIds = Hafas.bind(this.Controller.TP.selectFirstAvailableReturnTickets, this)(outwardDate);
      }
    }
    return showError;
  },

  selectFirstAvailableReturnTickets: function (outwardArrDate) {
    var connectionData = this.Controller.TP.currentTripResult.retConnections;
    var availableConnectionIds = [];
    for (var c = 0; c < connectionData.length; c++) {
      var conn = connectionData[c];
      var connDepDate = Hafas.Core.newType("hafasTime", {
        date: conn.date,
        time: conn.dep.dTimeS
      });
      if (connDepDate.jsDate >= outwardArrDate.jsDate) {
        availableConnectionIds.push({cid: conn.cid, con: conn});
      }
    }
    return availableConnectionIds;
  },

  actions: {
    onChangeOutDate: function (date) {
      this.Controller.TP.instance.setOutDate(date);
      var timeSelect = Hafas('#HFS_OutPeriodSelect');
      var jsDate = Hafas.Util.date.hciDate2jsDate(date);

      if (!Hafas.Util.date.isToday(jsDate) && timeSelect) {
        if (timeSelect.value == 0) {
          timeSelect.value = 1;
          Hafas.bind(this.Controller.TP.actions.onChangePeriod, this)(timeSelect.id, timeSelect.value);
        }
      }
      var jsRetDate = Hafas.Util.date.hciDate2jsDate(this.Controller.TP.instance.getRetDate());
      if (jsRetDate.getTime() < jsDate.getTime()) {
        Hafas.bind(this.Controller.TP.actions.onChangeRetDate, this)(date);
        this.Controller.TP.retDatePicker.setDate(date);
      }
      // Set return startdate to day of outward journey
      this.Controller.TP.retDatePicker.setStartDate(date);

      this.Controller.TP.retDatePicker.updateViews(true);
      this.Controller.TP.retDatePicker.updateDisplay();

      Hafas.bind(this.Controller.TP.onFormularChange, this)();

    },
    onChangeRetDate: function (date) {

      this.Controller.TP.instance.setRetDate(date);
      var timeSelect = Hafas('#HFS_RetPeriodSelect');
      var jsDate = Hafas.Util.date.hciDate2jsDate(date);

      if (!Hafas.Util.date.isToday(Hafas.Util.date.hciDate2jsDate(date)) && timeSelect) {
        if (timeSelect.value == 0) {
          timeSelect.value = 1;
          Hafas.bind(this.Controller.TP.actions.onChangePeriod, this)(timeSelect.id, timeSelect.value);
        }
      }
      Hafas.bind(this.Controller.TP.onFormularChange, this)();

      var jsOutDate = Hafas.Util.date.hciDate2jsDate(this.Controller.TP.instance.getOutDate());
      if (jsOutDate.getTime() > jsDate.getTime()) {
        Hafas.bind(this.Controller.TP.actions.onChangeOutDate, this)(date);
        this.Controller.TP.outDatePicker.setDate(date);
        this.Controller.TP.outDatePicker.updateViews();
        this.Controller.TP.outDatePicker.updateDisplay();
      }
      Hafas.bind(this.Controller.TP.onFormularChange, this)();
    },
    onChangePeriod: function (id, value) {
      var period = this.Controller.TP.timePeriodValues[value];
      switch (id) {
        case "HFS_OutPeriodSelect":
          this.Controller.TP.instance.setOutTimePeriod(period);
          break;
        case "HFS_RetPeriodSelect":
          this.Controller.TP.instance.setRetTimePeriod(period);
          break;
        case "HFS_RetPeriodSelectButtom":
          this.Controller.TP.instance.setRetTimePeriod(period);
          break;
        default:
      }

      Hafas.bind(this.Controller.TP.onFormularChange, this)();

    },
    onChangeReturn: function (value) {
      var jsOutDate = Hafas.Util.date.hciDate2jsDate(this.Controller.TP.instance.getOutDate());
      var outDateObj = Hafas.Util.date.jsDate2hciDate(jsOutDate);
      if (value) {
        Hafas("#HFS_RetDate_Input").removeAttribute('disabled');
        Hafas("#HFS_RetDate_Button").removeAttribute('disabled');
        Hafas("#HFS_RetPeriodSelect").removeAttribute('disabled');
        Hafas("#TP_ReturnInptsHolder").classList.remove('lyr_hideReturnInpts');
      } else {
        Hafas("#HFS_RetDate_Input").setAttribute('disabled', 'disabled');
        Hafas("#HFS_RetDate_Button").setAttribute('disabled', 'disabled');
        Hafas("#HFS_RetPeriodSelect").setAttribute('disabled', 'disabled');
        Hafas("#TP_ReturnInptsHolder").classList.add('lyr_hideReturnInpts');
        Hafas.bind(this.Controller.TP.actions.onChangeRetDate, this)(outDateObj.hciDate);
        this.Controller.TP.retDatePicker.setDate(outDateObj.hciDate);
        this.Controller.TP.retDatePicker.updateViews();
        this.Controller.TP.retDatePicker.updateDisplay();
      }

      this.Controller.TP.instance.setReturnEnabled(!!value);
      this.Controller.TP.dateRangeHandler.isActive = !!value;
      this.Controller.TP.ReturnEnabled = !!value;
      Hafas.bind(this.Controller.TP.onFormularChange, this)();
    },
    onAdultCount: function (name, value) {
      this.Controller.TP.instance.getPassangerOptions().setAdults(parseInt(value, 10));
      Hafas.bind(this.Controller.TP.onFormularChange, this)();
    },
    onChildCount: function (name, value) {
      this.Controller.TP.instance.getPassangerOptions().setChilds(parseInt(value, 10));
      Hafas.bind(this.Controller.TP.onFormularChange, this)();
    },
    onStudentCount: function (name, value) {
      this.Controller.TP.instance.getPassangerOptions().setStudents(parseInt(value, 10));
      Hafas.bind(this.Controller.TP.onFormularChange, this)();
    },
    onChooseDay: function (params) {
      var period = this.Controller.TP.timePeriodValues[1];
      var currentUrl = new URL(window.location.href);
      if (params.dir === "out") {
        this.Controller.TP.instance.setOutTimePeriod(period);
        Hafas("#HFS_OutPeriodSelect").value = 1;
        this.Controller.TP.instance.setOutDate(params.date);
        this.Controller.TP.outDatePicker.setDate(params.date);
        this.Controller.TP.outDatePicker.updateViews();
        this.Controller.TP.outDatePicker.updateDisplay();
        var jsDate = Hafas.Util.date.hciDate2jsDate(params.date);
        currentUrl.searchParams.set('REQ0JourneyDate',Hafas.Util.date.encodeURIHciDateString(params.date, false));
        history.pushState({}, "", currentUrl);

        if (this.Controller.TP.currentTripResult.query.returnEnabled) {
          var jsRetDate = Hafas.Util.date.hciDate2jsDate(this.Controller.TP.instance.getRetDate());
          Hafas("#HFS_RetPeriodSelect").value = 1;
          this.Controller.TP.instance.setRetTimePeriod(period);
          if (jsRetDate.getTime() < jsDate.getTime()) {
            this.Controller.TP.actions.onChooseRetDay.bind(this)(params.date);
            currentUrl.searchParams.set('REQ1JourneyDate',Hafas.Util.date.encodeURIHciDateString(params.date, false));
            history.pushState({}, "", currentUrl);
          }
        } else {
          Hafas("#HFS_RetPeriodSelect").value = 1;
          this.Controller.TP.actions.onChooseRetDay.bind(this)(params.date);
        }

      } else {
        Hafas("#HFS_RetPeriodSelect").value = 1;
        Hafas("#HFS_OutPeriodSelect").value = 1;
        this.Controller.TP.instance.setOutTimePeriod(period);
        this.Controller.TP.instance.setRetTimePeriod(period);
        this.Controller.TP.actions.onChooseRetDay.bind(this)(params.date);
      }
      Hafas.bind(this.Controller.TP.showWaitView, this)(Hafas.Modules.i18n.get('TP.index.t_N_WaitSearchConnection'));
      this.Controller.TP.ticketSelection.clear();
      this.Controller.TP.instance.search({ptCallback: Hafas.bind(this.Controller.TP.showResultOverview, this)});

    },

    onChooseRetDay: function (retDate) {

      Hafas('#HFS_RetDate_Input').value = Hafas.Util.date.hciDate2string(retDate);
      this.Controller.TP.instance.setRetDate(retDate);
      this.Controller.TP.retDatePicker.setDate(retDate);
      this.Controller.TP.retDatePicker.updateViews();
      this.Controller.TP.retDatePicker.updateDisplay();
      var currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('REQ1JourneyDate', Hafas.Util.date.encodeURIHciDateString(retDate,false));
      history.pushState({}, "", currentUrl);
    },
    focusTicket: function (params) {

      /*console.log(params)*/
    },
    selectTicket: function (params) {

      var errorObj = {};
      var ticket = Hafas.Modules.Render.objectKeeper.get(params.ticketKey);
      var searchResult = Hafas.bind(this.Controller.TP.getConnectionById, this)(params.cid);

      if (searchResult === null) {
        console.log("Error: Connection not found!");
        return;
      }

      Hafas.bind(this.Controller.TP.unselectAllTicketsOfDir, this)(searchResult.dir);
      if (!this.Controller.TP.currentTripResult.query.returnEnabled) {
        this.Controller.TP.ticketSelection.setOutwardTicket(ticket, searchResult.connection);
        Hafas.bind(this.Controller.TP.selectTicketInGui, this)(params.cid, ticket);
        Hafas.bind(this.Controller.TP.upgradePricesGui, this)(searchResult.connection.resolvedTariffs, ticket, params.cid);
        Hafas.bind(this.Controller.TP.renderTicketBanner, this)();
        return;
      }

      if (searchResult.dir === "out") {
        this.Controller.TP.ticketSelection.removeOutwardTicket();
        errorObj = Hafas.bind(this.Controller.TP.checkSelectedOutwardDate, this)(searchResult);
      } else {
        this.Controller.TP.ticketSelection.removeReturnTicket();
        errorObj = Hafas.bind(this.Controller.TP.checkSelectedReturnDate, this)(searchResult);
      }

      if (errorObj.status) {
        this.Controller.TP.actions.showReturnHintOverlay.bind(this)(params.cid, searchResult.dir, errorObj);
        return;
      }

      if (searchResult.dir === "out") {
        this.Controller.TP.ticketSelection.setOutwardTicket(ticket, searchResult.connection);
      } else {
        this.Controller.TP.ticketSelection.setReturnTicket(ticket, searchResult.connection);
      }
      Hafas.bind(this.Controller.TP.selectTicketInGui, this)(params.cid, ticket);
      Hafas.bind(this.Controller.TP.upgradePricesGui, this)(searchResult.connection.resolvedTariffs, ticket, params.cid);
      Hafas.bind(this.Controller.TP.renderTicketBanner, this)();
    },
    bookTicket: function () {

      var params = {
        passengerOptions : this.Controller.TP.instance.getPassangerOptions(),
        passengersType : Hafas.Config.TP.passengersType,
        showPopup : false,
        popupTitle: Hafas.Modules.i18n.get("TP.index.t_N_OverlayWheelChairTitle")
      }

      for (var i = 0; i < params.passengersType.length; i++) {
        var type = params.passengersType[i];
        if (params.passengerOptions[type].length > 0) {
          if(type !== 'adult') {
            params.showPopup = true;
            params.popupTitle = Hafas.Modules.i18n.get("TP.index.t_N_OverlayTermsAndConditions");
          }
          for (var a = 0; a < params.passengerOptions[type].length; a++) {
            if (params.passengerOptions[type][a].wheelchairUser) {
              params.showPopup = true;
            }
          }
        }
      }

      if (params.showPopup) {
        this.Controller.TP.actions.showTermsConditionsPopup.bind(this)(params);
      } else {
        this.Controller.TP.actions.jumpToTicketShop.bind(this)();
      }

    },
    jumpToTicketShop: function () {
      var url = Hafas.bind(this.Controller.TP.createBookTicketURL, this)();
      if (url == null)
        return;

      /// resolve gtm obj
      var impressions = [],
      JourneyDir = [],
      passengers = this.Controller.TP.currentTripResult.query.passangerOptions,
      ticketSelection = this.Controller.TP.ticketSelection;


      if (ticketSelection.selectedOutwardConnection !== null) JourneyDir.push({
        code: 'Outward',
        name: Hafas.Modules.i18n.get('TP.index.t_N_Single'),
        id: 1,
        type: (ticketSelection.selectedReturnConnection !== null) ? Hafas.Modules.i18n.get('TP.index.t_N_OutwardJourney') : Hafas.Modules.i18n.get('TP.index.t_N_Single'),
      });
      if (ticketSelection.selectedReturnConnection !== null) JourneyDir.push({
        code: 'Return',
        name: Hafas.Modules.i18n.get('TP.index.t_N_ReturnJourney'),
        id: 2,
        type: Hafas.Modules.i18n.get('TP.index.t_N_ReturnJourney')
      });


      Hafas.Config.TP.passengersType.forEach(function (item) {
        var personType = item,
        personTypeArr = passengers[personType],
        quantityredtnCard = personTypeArr.filter(function (passenger) {
          return passenger.redtnCard
        }),
        quantity = personTypeArr.length - quantityredtnCard.length
        if (personTypeArr.length > 0) {
          for (var i = 0; i < personTypeArr.length; i++) {
            var redtnCard = personTypeArr[i].redtnCard,
            gtmDimension4 = Hafas.Modules.i18n.get('TP.index.t_N_FullPrice');
            if (redtnCard) gtmDimension4 = Hafas.Modules.i18n.get('TP.index.t_N_SeatReservationOnly');
            JourneyDir.forEach(function (dir) {

              var ticketPrice = ticketSelection['selected' + dir.code + 'Ticket'].price;
              var ticketType = ticketSelection['selected' + dir.code + 'Ticket'].texts.name;
              var gtmObj = {
                name: dir.type,
                id: dir.type,
                price: Hafas.Util.format.money(ticketPrice / personTypeArr.length, " ", Hafas.Config.Tariffs.priceFormats[ticketPrice / personTypeArr.length]),
                //price: Hafas.Util.format.money(ticketPrice, " ", Hafas.Config.Tariffs.priceFormats[ticketPrice]),
                variant: personType,
                category: ticketType,
                list: dir.type,
                dimension1: ticketSelection['selected' + dir.code + 'Connection'].dep.locResolved.name,
                dimension2: ticketSelection['selected' + dir.code + 'Connection'].arr.locResolved.name,
                dimension4: gtmDimension4,
                position: dir.id,
                // change the quantity value base on https://jira.local.hacon.de/browse/HCUIRAIL-595
                //quantity: quantity
                quantity: 1
              };
              impressions.push(gtmObj);
            })
          }
        }
      })

      this.Controller.TP.actions.tgmDataLayer(impressions, url);
      //console.log(impressions)
      location.href = url;
    },
    tgmDataLayer: function (param) {
      //console.log(window['google_tag_manager']);
      var gtmParam = {
        event: 'addToCart',
        ecommerce: {
          currencyCode: 'EUR',
          add: {
            products: param
          }
        }
      };

      dataLayer.push(gtmParam);
    },
    chooseOutward: function () {
      var node = Hafas("#HFS_TPOverviewResults");
      var selectedDay = Hafas("#HFS_TpOutDateChooser .lyr_dateChooserDayHolder .lyr_selected");
      var nodeResults = Hafas("#HFS_TPOverviewResults .lyr_itemResults .lyr_connectionPriceBlock button");
      if (node) {
        if (nodeResults === null) {
          selectedDay.nextElementSibling.focus();

        } else {
          nodeResults[0].focus();
        }
        Hafas.Util.scollToTop(node);
      }
      Hafas.bind(this.Controller.TP.onFormularChange, this)();
    },
    chooseSocialOutward: function (param) {
      var scrollToItem = null;
      var resultsContainer = Hafas('#HFS_TPOverviewResults');
      if (param.aId !== -1) {
        scrollToItem = Hafas('#HFS_ConnectionId_' + param.aId, resultsContainer, false)[0];
        Hafas.Util.scollToTop(scrollToItem);
      } else {
        Hafas.bind(this.Controller.TP.actions.chooseOutward, this)();
      }
    },
    chooseReturn: function () {
      var node = Hafas("#HFS_TpConnectionRetAchor");
      Hafas.Util.scollToTop(node);
      /*var selectedDay = Hafas("#HFS_TpOutDateChooser .lyr_dateChooserDayHolder .lyr_selected");
      var nodeResults = Hafas("#HFS_TPOverviewRetResults .lyr_itemResults .lyr_connectionPriceBlock button");*/
      /* if (node) {
         if (nodeResults === null) {
           selectedDay.nextElementSibling.focus();

         } else {
           nodeResults[0].focus();
         }
         Hafas.Util.scollToTop(node);
       }*/
      Hafas.bind(this.Controller.TP.onFormularChange, this)();
    },
    chooseSocialReturn: function (param) {
      var scrollToItem = null;
      var resultsContainer = Hafas('#HFS_TPOverviewRetResults');
      if (param.aId !== "-1") {
        scrollToItem = Hafas('#HFS_ConnectionId_' + param.aId, resultsContainer, false)[0];
        Hafas.Util.scollToTop(scrollToItem);
      } else {
        Hafas.bind(this.Controller.TP.actions.chooseReturn, this)();
      }
    },
    showPassengerOptions: function (el) {
      var html = Hafas.Modules.Render.renderTemplate("TP_AtomPassangerOverlay", this.Controller.TP.instance.getPassangerOptions());
      var _me = this;
      Hafas.Core.newType("HafasOverlay", {
        id: "PassangerOverlay",
        app: this,
        title: Hafas.Modules.i18n.get('common.label.t_N_Passanger'),
        outputHTML: html,
        callback: function () {
          var inputs = Hafas("#HFS_OverlayPassangerOverlay input");
          _me.Controller.TP.tmpCurrPassangerCount =  _me.Controller.TP.instance.getPassangerOptions().getAllPassangers().length;
          inputs.forEach(function (input, idx) {
            var curCount = parseInt(input.value, 10);
            input.setAttribute('max', Hafas.Config.TP.maxPassangerCount);
            if (curCount === 0) {
              input.previousElementSibling.setAttribute('disabled', "disabled");
            }
          })
          Hafas.bind(_me.Controller.TP.actions.reachedMaxPassangerCount, _me)();
        }
      });
    },
    changePassangerCount: function (type, value, trigger) {

      var input = Hafas("#HFS_PassangerOptionInput_" + type);
      var minusBtn = input.previousElementSibling;
      var curCount = parseInt(input.value, 10);
      var srOnlyHolder = Hafas("#" + type + "PassengersCounter");
      curCount += value;
      if (curCount <= 0) {
        curCount = 0;
        value = -1;
        minusBtn.setAttribute('disabled', "disabled");
      }

      this.Controller.TP.tmpCurrPassangerCount += value;
      input.value = curCount || parseInt(input.getAttribute('min'), 10);


      // display warning message if no passengers are selected
      if (this.Controller.TP.tmpCurrPassangerCount === 0) {
        this.Controller.TP.actions.setPassengerWarningMessage(
        Hafas.Modules.i18n.get('Overlay.t_N_passengerInfoWarning.t_N_NoPassengersSelected')
        );
        this.Controller.TP.actions.toggleApplyButtonState(true);
      } else {
        Hafas.bind(this.Controller.TP.actions.reachedMaxPassangerCount, this)();
      }

      var srMsg = 'passengers';
      if (curCount === 1) {
        srMsg = 'passenger'
      }
      srOnlyHolder.innerHTML = curCount + ' ' + srMsg;
      if (trigger.type === "number") {
        srOnlyHolder.removeAttribute('aria-live');
      } else {
        srOnlyHolder.setAttribute('aria-live', 'polite');
      }
    },
    savePassengerOptions: function () {
      var passengerOptions = this.Controller.TP.instance.getPassangerOptions();
      var passengersType = Hafas.Config.TP.passengersType;
      var counts = {};

      passengersType.forEach(function(type) {
        var selector = '#HFS_PassangerOptionInput_' + type;
        counts[type] = parseInt(Hafas(selector).value, 10) || 0;
      });
      if (Object.values(counts).every(function(count) { return count === 0; })) {
        counts.adult = 1;
        Hafas("#TP_passengersWheelchair").removeClassName('lyr_selected');
      }

      // Set passenger options dynamically based on types
      passengerOptions.setAdults(counts.adult);
      passengerOptions.setChilds(counts.child);
      passengerOptions.setStudents(counts.student);
      passengerOptions.setFreeTravelPass(counts.freeTravelPass);
      passengerOptions.setReservationOnly(counts.reservationOnly);

      if (counts.freeTravelPass > 0) {
        Hafas.bind(this.Controller.TP.actions.applyReductionCard, this)({type: 'freeTravelPass', count: counts.freeTravelPass, redtnCard: 2});
      }
      if (counts.reservationOnly > 0) {
        Hafas.bind(this.Controller.TP.actions.applyReductionCard, this)({type: 'reservationOnly', count: counts.reservationOnly, redtnCard:1});
      }

      // Update current passenger count
      this.Controller.TP.currPassangerCount = Object.values(counts).reduce(function(total, count) {
        return total + count;
      }, 0);

      // Hide overlay and update display
      Hafas.ps.pub('/common/hideOverlay', ['PassangerOverlay']);
      Hafas.bind(this.Controller.TP.actions.updatePassengerOptionsDisplay, this)(passengerOptions);
      Hafas.bind(this.Controller.TP.onFormularChange, this)();
    },

    updatePassengerOptionsDisplay: function (passengerOptions) {

      var allPassengers = passengerOptions.getAllPassangers().length;
      var passengerOptionsButton = Hafas("#HAF_PassengerSelectButton", false);
      var model = {};
      model.allPassangers = allPassengers;
      var html = Hafas.Modules.Render.renderTemplate("TP_PassengerSelectText", model);

      if (passengerOptionsButton){
        passengerOptionsButton.innerHTML = html;
      }

    },
    showWheelchairOptions: function () {
      var passengerOptions = this.Controller.TP.instance.getPassangerOptions();
      var passengerOverview = passengerOptions.getPassangerOverview();
      var model = {
        passengerOptions: passengerOptions,
        passengerOverview: passengerOverview
      }
      var html = Hafas.Modules.Render.renderTemplate("TP_AtomWheelchairOverlay", model);
      var _me = this
      Hafas.Core.newType("HafasOverlay", {
        id: "WheelchairOverlay",
        app: this,
        title: Hafas.Modules.i18n.get("TP.index.t_N_OverlayWheelChairTitle"),
        outputHTML: html,
        callback: function () {
          var passengerOptions = _me.Controller.TP.instance.getPassangerOptions()
          for (var i in Hafas.Config.TP.passengersType) {
            var inp = Hafas("#HFS_WheelchairOptionInput_" + Hafas.Config.TP.passengersType[i]);
            if (inp !== null) {
              Hafas.bind(_me.Controller.TP.actions.toggleDisabledButtons, _me)(inp,passengerOptions[Hafas.Config.TP.passengersType[i]].length);
            }
          }
        }
      });

    },
    saveWheelcharOptions: function () {

      var passengerOptions = this.Controller.TP.instance.getPassangerOptions(),
      count, is_changed = false;

      for (var i in Hafas.Config.TP.passengersType) {
        var inp = Hafas("#HFS_WheelchairOptionInput_" + Hafas.Config.TP.passengersType[i]);
        if (inp !== null) {
          count = parseInt(inp.value, 10);
          passengerOptions.setWheelChairUsersSingleType({
            count: count,
            type: Hafas.Config.TP.passengersType[i]
          });
          if (count > 0) is_changed = true;
        }
      }

      if (is_changed) {
        Hafas("#TP_passengersWheelchair").addClassName('lyr_selected');
      } else {
        Hafas("#TP_passengersWheelchair").removeClassName('lyr_selected');
      }

      Hafas.ps.pub('/common/hideOverlay', ['WheelchairOverlay']);
      Hafas.bind(this.Controller.TP.onFormularChange, this)();
    },
    changeWheelchairCount: function (type, value) {

      var passengerOptions = this.Controller.TP.instance.getPassangerOptions();
      var input = Hafas("#HFS_WheelchairOptionInput_" + type);
      var curCount = parseInt(input.value, 10);
      var srOnlyHolder = Hafas("#" + type + "WheelchairCounter");


      if (isNaN(curCount)) {
        curCount = 0;
      }
      curCount += value;
      if (curCount < 0) {
        curCount = 0;
      }
      if (curCount > passengerOptions[type].length) {
        curCount = passengerOptions[type].length;
        input.setAttribute('aria-label', Hafas.Modules.i18n.get("Overlay.t_N_Max") + passengerOptions[type].length);

      } else {
        input.removeAttribute("aria-label");
      }

      var srMsg = 'Wheelchairs';
      if (curCount === 1) {
        srMsg = 'Wheelchair';
      }
      srOnlyHolder.innerHTML = curCount + ' ' + srMsg;
      input.value = curCount;
      Hafas.bind(this.Controller.TP.actions.toggleDisabledButtons, this)(input, passengerOptions[type].length);
    },
    showSeatOnlyOptions: function () {

      var passengerOptions = this.Controller.TP.instance.getPassangerOptions();
      var model = {passangerList: passengerOptions.getAllPassangers()};
      var html = Hafas.Modules.Render.renderTemplate("TP_AtomSeatOnlyOverlay", model);
      Hafas.Core.newType("HafasOverlay", {
        id: "SeatOnlyOverlay",
        app: this,
        title: Hafas.Modules.i18n.get("TP.index.t_N_OverlaySeatOnlyTitle"),
        outputHTML: html,
        callback: function (html, err) {
        }
      });
    },
    saveSeatOnlyOptions: function () {
      var passengerOptions = this.Controller.TP.instance.getPassangerOptions();
      var passangerList = passengerOptions.getAllPassangers();
      var is_checked = false;
      for (var i = 0; i < passangerList.length; i++) {
        var checkbox = Hafas("#HFS_SeatOnlyCheckbox_" + i);
        passangerList[i].setSeatOnly(checkbox.checked);
        is_checked = checkbox.checked;
      }

      for (var i = 0; i < passangerList.length; i++) {
        var checkbox = Hafas("#HFS_SeatOnlyCheckbox_" + i);
        is_checked = checkbox.checked;
        if (is_checked) break;
      }

      if (is_checked) {
        Hafas("#TP_passengersSeat").addClassName('lyr_selected');
      } else {
        Hafas("#TP_passengersSeat").removeClassName('lyr_selected');
      }

      Hafas.ps.pub('/common/hideOverlay', ['SeatOnlyOverlay']);
      Hafas.bind(this.Controller.TP.onFormularChange, this)();
    },
    applyReductionCard: function (params) {
      var passengersList = this.Controller.TP.instance.getPassangerOptions()[params.type];
      for (var i = 0; i < passengersList.length; i++) {
        var passengers = passengersList[i];
        passengers.setSeatOnly(params.redtnCard);
      }
    },
    showTermsConditionsPopup: function (model) {

      var html = Hafas.Modules.Render.renderTemplate("TP_TplTermsConditionsPopup", model);
      Hafas.Core.newType("HafasOverlay", {
        id: "TermsConditions",
        app: this,
        title: model.popupTitle,
        outputHTML: html,
        callback: function (html, err) {
        }
      });
    },
    showReturnHintOverlay: function (cid, dir, errObj) {
      if (dir === "out") {
        this.Controller.TP.ticketSelection.removeOutwardTicket();
      } else {
        this.Controller.TP.ticketSelection.removeReturnTicket();
      }
      Hafas.bind(this.Controller.TP.renderTicketBanner, this)();
      var model = {
        currId: cid,
        aId: -1,
        dir: dir,
        WarningMsg: errObj.msg
      }
      if (errObj.aIds.length > 0) {
        if (dir === "out") {
          var overlyTitle = Hafas.Modules.i18n.get("TP.index.t_N_OverlayReturnTripTitle");
          model.aId = errObj.aIds[errObj.aIds.length - 1].cid;
        } else {
          var overlyTitle = Hafas.Modules.i18n.get("TP.index.t_N_OverlayOutwardTripTitle");
          model.aId = errObj.aIds[0].cid;
        }
      }
      var html = Hafas.Modules.Render.renderTemplate("TP_TplReturnHintPopup", model);
      Hafas.Core.newType("HafasOverlay", {
        id: "ReturnTicketOverlay",
        app: this,
        title: overlyTitle,
        outputHTML: html,
        callback: function (html, err) {
        }
      });
    },
    setBikeFilter: function (bool) {
      this.Controller.TP.instance.setBikeFilter(bool);
      if (bool) {
        Hafas("#TP_setBike").addClassName('lyr_selected');
      } else {
        Hafas("#TP_setBike").removeClassName('lyr_selected');
      }
      Hafas.bind(this.Controller.TP.onFormularChange, this)();
    },
    jumpToBooking: function () {
      Hafas("#HFS_PriceButtonDetails_Tab").focus();
    },
    toggleDisabledButtons: function (input, maxCount) {
      var plusBtn = input.nextElementSibling,
      minusBtn = input.previousElementSibling,
      maxVal = parseInt(maxCount, 10),
      minVal = parseInt(input.getAttribute('min'), 10),
      curCount = parseInt(input.value, 10);
      switch (true) {
        case (curCount > minVal && curCount < maxVal):
          minusBtn.removeAttribute('disabled');
          plusBtn.removeAttribute('disabled');
          break;
        case (curCount === maxVal):
          minusBtn.removeAttribute('disabled');
          plusBtn.setAttribute('disabled', "disabled");
          input.focus();
          break;
        case (curCount === minVal):
          minusBtn.setAttribute('disabled', "disabled");
          plusBtn.removeAttribute('disabled');
          input.focus();
          break;
        default:
          break;
      }
    },
    reachedMaxPassangerCount: function () {

      var passengersType = Hafas.Config.TP.passengersType;

      for (var p = 0; p < passengersType.length; p++) {
        var input = Hafas("#HFS_PassangerOptionInput_" + passengersType[p]);
        var plusBtn = input.nextElementSibling;
        var minusBtn = input.previousElementSibling;
        var curCount = parseInt(input.value, 10);

        if (this.Controller.TP.tmpCurrPassangerCount == Hafas.Config.TP.maxPassangerCount) {
          plusBtn.setAttribute('disabled', "disabled");
          minusBtn.setAttribute('disabled', "disabled");
        }else{
          plusBtn.removeAttribute('disabled');
        }

        if(curCount !== 0){
          minusBtn.removeAttribute('disabled');

        }
      }

      if (this.Controller.TP.tmpCurrPassangerCount == Hafas.Config.TP.maxPassangerCount) {
        this.Controller.TP.actions.setPassengerWarningMessage(
        Hafas.Modules.i18n.get('Overlay.t_N_passengerInfoWarning.t_N_MaxPassengersReached')
        );
      }else{
        this.Controller.TP.actions.setPassengerWarningMessage("");
        this.Controller.TP.actions.toggleApplyButtonState(false);
      }
    },
    passengerInfoPopUpOverlay: function (popupId){
      var _me = this;
      var model = ''

      for (var i = 0; i< 5; i++)  {
        model += '<div class="lyr_PassengerInfoPopup_row">';
        model += '<h3>' + Hafas.Modules.i18n.get('Overlay.t_N_passengerInfoPopupQuestions.t_N_question_' + i) + '</h3>';
        model +=  Hafas.Modules.i18n.get('Overlay.t_N_'+popupId+'_Answers.t_N_answer_' + i);
        model +=  '</div>';
      }
      var html = Hafas.Modules.Render.renderTemplate("TP_TplPassengerInfoPopup", {model:model});
      Hafas.Core.newType("HafasOverlay", {
        id: "passengerInfoPopUpOverlay",
        app: _me,
        title: Hafas.Modules.i18n.get('Overlay.t_N_'+popupId+'_PopupTitle'),
        outputHTML: html,
        cssClass: 'hfs_overlayMap',
        onClose: function () {

        },
        callback: function (html, err) {

        }
      });
    },
    setPassengerWarningMessage: function( message) {
      var container = Hafas("#HFS_OverlayPassangerOverlay .lyr_formWarningMessage", false);
      if (container) {
        container.innerText = message || "";
      }
    },
    toggleApplyButtonState: function (disable) {
      var button = Hafas("#HFS_OverlayPassangerOverlay .lyr_applyBtn", false);
      if (button) {
        if (disable) {
          button.setAttribute('disabled', "disabled");
        } else {
          button.removeAttribute('disabled');
        }
      }
    }
  },
  // Kundenanpassung Map
  showRouteMap: function (params) {
    var tpController = this.Controller.TP;
    var cid = params.cid;
    if (Hafas.Modules.Map == undefined) {
      tpController.instance.loadMapModule(Hafas.bind(function () {
        Hafas.bind(tpController.renderRouteMap, this)(cid);

      }, this));
    } else {
      Hafas.bind(tpController.renderRouteMap, this)(cid);
    }


  },
  hideRouteMap: function (params) {
    var cid = params.cid;
    var conHolder = Hafas("#HFS_ConnectionId_" + cid);
    conHolder.removeClassName("lyr_showMap");
  },
  renderRouteMap: function (cid) {
    if (Hafas.Util.getLayoutClass() === "small") {
      Hafas.bind(this.Controller.TP.renderRouteMapInPopup, this)(cid);
    } else {
      Hafas.bind(this.Controller.TP.renderRouteMapInContainer, this)(cid);
    }
  },
  renderRouteMapInPopup: function (cid) {
    var tpController = this.Controller.TP;
    var _me = this;
    var html = Hafas.Modules.Render.renderTemplate("TP_TplRouteMapPopup", {});
    Hafas.Core.newType("HafasOverlay", {
      app: _me,
      title: Hafas.Modules.i18n.get('TP.results.t_N_DetailsMapHeader'),
      outputHTML: html,
      cssClass: 'hfs_overlayMap',
      onClose: function () {
        console.log('Overlay closed');
      },
      callback: function (html, err) {
        if (err) console.error(err);
        tpController.createRouteMap(cid, "HFS_TpRouteMap");
        tpController.addSpecialMapA11y("#HFS_TpRouteMap");
      }
    });
  },
  renderRouteMapInContainer: function (cid) {
    var conHolder = Hafas("#HFS_ConnectionId_" + cid);
    conHolder.addClassName("lyr_showMap");
    if (conHolder.hasAttribute("has-map"))
      return;
    conHolder.setAttribute("has-map", "yes");
    this.Controller.TP.createRouteMap(cid, "HFS_DetailsMapContainer_" + cid);
    this.Controller.TP.addSpecialMapA11y("#HFS_DetailsMapContainer_" + cid);
  },
  addSpecialMapA11y: function (container) {
    Hafas(container + ' .leaflet-control-container .hfs_mapButtonCustom ').setAttribute('aria-label', Hafas.Modules.i18n.get('a11y.t_N_ShowYourPositioOnMap'));
    var mapMarkers = Hafas(container + ' .leaflet-map-pane .leaflet-marker-pane img.leaflet-marker-icon', true);
    mapMarkers.forEach(function (el, idx) {
      el.setAttribute('aria-hidden', 'true');
      el.tabIndex = '-1';
    })
    var mapLocationMarker = Hafas(container + " .leaflet-map-pane .leaflet-marker-pane .hfs_locationMarker", true);
    var mouseOverEvent = new MouseEvent('mouseover', {
      'view': window,
      'bubbles': true
    });
    var mouseOutEvent = document.createEvent('MouseEvents');
    mouseOutEvent.initMouseEvent('mouseout', true, true);
    mapLocationMarker.forEach(function (el, idx) {
      var mouseOverOnEl = null;
      el.addEventListener('focus', function () {

        var dir = Hafas('.lyr_srOnly', false, this).getAttribute('data-dir');
        if (dir === 'Dep') {
          mouseOverOnEl = mapMarkers[0];
        }
        if (dir === 'Arr') {
          mouseOverOnEl = mapMarkers[1];
        }
        mouseOverOnEl.dispatchEvent(mouseOverEvent);
      })
      el.addEventListener('blur', function () {
        mouseOverOnEl.dispatchEvent(mouseOutEvent);
      })

      if (Hafas('.lyr_srOnly', false, el) === null) {
        el.tabIndex = '-1';
      }
    })
  },
  createRouteMap: function (cid, container) {
    if (typeof L == "undefined") {
      setTimeout(function () {
        this.createRouteMap(cid);
      }.bind(this), 300);
      return;
    }
    var initCoord = Hafas.Core.newType("hafasCCoord", {
      lon: Hafas.Config.Maps.predefinedArea.lon,
      lat: Hafas.Config.Maps.predefinedArea.lat
    });
    var mapConfigParams = {
      coord: initCoord,
      zoom: Hafas.Config.Maps.predefinedZoom,
      reverseLookup: false,
      layer: [{
        "name": "HAFAS BaseLayer",
        "id": "HafasBaseMap",
        "type": "static",
        "url": Hafas.Config.staticTileURL,
        "attribution": "&copy; OpenStreetMap contributors",
        "isBaseLayer": true
      }],
      baseLayer: Hafas.Config.Maps.baseLayer
    };
    if (typeof Hafas.Config.Maps.controls != 'undefined') {
      mapConfigParams.controls = Hafas.Config.Maps.controls;
    }

    this.maps = this.maps || {}
    this.maps[cid] = Hafas.Core.newType("hafasMap" + Hafas.Config.Maps.mapApi, container, mapConfigParams);
    var conMapObj = Hafas.Core.newType("hafasConnection", this.currentConnectionData[cid].connection, this.maps[cid]);
    conMapObj.show();
  },
  showGeoPosition: function (map) {
    var maps = this.maps, mapInstance;
    var keysOfMaps = Object.keys(maps);
    keysOfMaps.forEach(function (mapInst) {
      if (map._container.id === maps[mapInst].id) {
        mapInstance = maps[mapInst];
      }
    });

    if (typeof Hafas.Config.Maps.usePositionWatcher !== "undefined" && Hafas.Config.Maps.usePositionWatcher) {
      // Callback wird jedes mal, wenn die Position geändert wird getriggert.
      // Es soll jedoch nicht jedesmal die aktuelle Position zentriert werden.
      mapInstance.activePositionWatcher = false;
      var _watcherCallback = function (position) {
        if (position && !mapInstance.activePositionWatcher && typeof position.browserPosition !== 'undefined') {

          var crd = Hafas.Util.geo.browserLatLngToHafasCoord(position.browserPosition.coords);
          mapInstance.centerToGeo(crd, Hafas.Config.Maps.searchPredefinedZoom);
          mapInstance.activePositionWatcher = true;
        }
      };
      Hafas.Util.geo.activateActualPositionWatcher(Hafas.bind(_watcherCallback, this), true);
    } else {
      // Alte Funktion:
      Hafas.Util.getGeoLocation(Hafas.bind(function (geoLoc) {
        if (typeof geoLoc.coords != 'undefined') {
          var crd = Hafas.Util.geo.browserLatLngToHafasCoord(geoLoc.coords);
          mapInstance.centerToGeo(crd, Hafas.Config.Maps.searchPredefinedZoom);
        }
      }, this), false, true);
    }
    // Tracking
    Hafas.ps.pub('/tracking/event/map-current-position-button-clicked', [{
      typ: 'event',
      key: 'map-current-position-button-clicked'
    }]);
    Hafas.ps.pub('/tracking/event/map-currentposition-pressed', [{typ: 'event', key: 'map-currentposition-pressed'}]);
  }
};
